<div class="overlay" *ngIf="executingTaskSvc.showFullPageSpinner.value">
  <div
    style="
      display: flex;
      flex-direction: column;
      gap: 20px;
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      margin: 0px;
    "
  >
    <div style="order: 1; flex: 100">
      <table>
        <thead>
          <tr>
            <th style="width: 450px">Task</th>
            <th style="width: 100px; text-align: center">Status</th>
            <th style="width: 150px; text-align: center">Duration</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let task of executingTaskSvc.executingTasks">
            <td style="width: 450px">{{ task.task }}</td>
            <td
              style="width: 100px; text-align: center; align-content: center"
              *ngIf="task.statusImage?.toString() == 'Spinner'"
            >
              <img
                src="img/clock.svg"
                alt="Loading..."
                height="35px"
                width="35px"
              />
            </td>
            <td
              style="width: 100px; text-align: center; align-content: center"
              *ngIf="task.statusImage?.toString() == 'Success'"
            >
              <img
                src="img/system-check.svg"
                alt="Success"
                height="35px"
                width="35px"
              />
            </td>
            <td
              style="width: 100px; text-align: center; align-content: center"
              *ngIf="task.statusImage?.toString() == 'Error'"
            >
              <img
                src="img/system-error.svg"
                alt="Error"
                height="35px"
                width="35px"
              />
            </td>
            <td style="width: 150px; text-align: center">
              {{ task.duration }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
